import React from 'react';
import Layout from '../components/Layout';
import SEO from '../components/Seo';
import ServiceCard from '../components/ServiceCard';

const services = {
  lenders: [
    'New Construction',
    'Rent Controlled Apartments',
    'Urban & suburban office',
    'Industrial',
    'Urban Mixed use properties',
    'Subdivisions & Condominiums',
    'Vacant Land',
    'Historic Properties',
    'Leasehold & Land Leases',
    'Hospitality',
    'Religious & Entertainment facilities',
  ],
  individuals: [
    'Estate Tax purposes',
    'Non-litigious partner buy outs',
    'Market rent analysis',
    'Gift tax filing',
    'Internal decision making',
    '409a Valuations',
    'Vacant Land',
    'Fractional Interest Valuation (a.k.a.“discount studies”)',
  ],
  agencies: [
    'Internal decision making',
    'Market rent analysis',
    'Publicly owned property',
    'Right of Way',
    'Acquisition / Disposition',
    'Qualified appraisals for donated Property',
  ],
};

const Services = () => {
  return (
    <Layout>
      <SEO siteTitle='Services' />
      <div className='flex flex-col px-10 lg:px-32 py-20 md:py-40 items-center'>
        <p className='text-xl w-11/12 xl:w-1/2 text-center mb-16'>
          Thank you for your interest in our services. We offer narrative style
          appraisals for an array of clients
        </p>
        <div className='grid grid-cols-1 xl:grid-cols-2  2xl:grid-cols-3 gap-y-16 lg:gap-x-16'>
          <ServiceCard serviceTitle='Lenders' services={services.lenders}>
            <span className='font-bold'>FIRREA</span> and{' '}
            <span className='font-bold'>SBA</span> compliant commercial real
            estate appraisals. We are competent with an array of unique asset
            types, including:
          </ServiceCard>
          <ServiceCard
            serviceTitle='Individuals'
            services={services.individuals}
          />
          <ServiceCard
            serviceTitle='Agencies/Institutions'
            services={services.agencies}
          />
        </div>
      </div>
    </Layout>
  );
};

export default Services;
